// #739 / #722: all driver-login consent and SMS disclosure copy lives here.
//
// LOGIN_CONSENT_VERSION identifies the consent terms a driver accepted. Every driver who has
// not accepted this exact version is asked for consent once at their next login.
//
// Change it ONLY when the consent terms themselves change in a way that requires renewed
// acceptance (a decision for legal/product). Do NOT change it for deployments, design or
// layout work, link styling, typo fixes that don't change meaning, or the SMS disclosure.
// It is a hand-set constant and is never derived from builds or dates automatically.
// It must equal CURRENT_VERSION in auth/consent.py (tests/test_auth_login_consent.py fails
// otherwise), so both are changed together in one reviewed commit.

export const LOGIN_CONSENT_VERSION = '2026-10-21';

export const TERMS_URL = '/terms';
export const PRIVACY_URL = '/privacy';

// Link labels inside the texts below. The modal turns each occurrence into a link that
// opens in a new tab.
export const POLICY_LINKS = [
    { label: 'Terms of Use', href: TERMS_URL },
    { label: 'Privacy Policy', href: PRIVACY_URL },
];

// Box 1. Required: login stays disabled until it is checked.
export const SERVICE_CONSENT_TEXT = 'I agree to the CarFido Terms of Use and Privacy Policy, and to receive '
    + 'account and service messages from CarFido by text and email, such as login codes and updates on my repairs.';

// Box 2. Optional: never blocks login, recorded separately from service consent.
export const MARKETING_CONSENT_TEXT = 'Send me tips, offers and promotions from CarFido by text and email. '
    + 'Consent is not required to use CarFido.';

export const ANONYMOUS_CHAT_NOTICE = 'By using CarFido, you agree to our Terms of Use and Privacy Policy.';

// #722: shown under the phone number field, Phone login only.
export const SMS_DISCLOSURE_TEXT = 'Message frequency varies. Msg & data rates may apply. Reply STOP to opt out, '
    + 'HELP for help. See our Terms of Use and Privacy Policy.';

// Consent payload sent to /auth/accept-login-consent after code verification.
export function buildLoginConsentPayload({ serviceAccepted, marketingOptIn, sourcePage }) {
    return {
        service_accepted: Boolean(serviceAccepted),
        marketing_opt_in: Boolean(marketingOptIn),
        copy_version: LOGIN_CONSENT_VERSION,
        source_page: String(sourcePage || '').slice(0, 500),
    };
}
